import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { DEFAULT_MUI_DATATABLE_BUTTON_SIZE } from 'constantes/constants';
import AttachFile from '@mui/icons-material/AttachFile';
import useAuth from 'hooks/useAuth';

const AttachButton = ({ onClick, requiredPermissions = '', disabled }) => {
  const { checkAccess } = useAuth();
  const hasAccess = checkAccess(requiredPermissions);
  if (!hasAccess) return null;

  const isDisabled = Boolean(disabled);
  return (
    <IconButton
      size={DEFAULT_MUI_DATATABLE_BUTTON_SIZE}
      sx={{
        '&:hover': (theme) => ({
          color: theme.palette.primary.main
        })
      }}
      onClick={onClick}
      disabled={isDisabled}
    >
      <AttachFile />
    </IconButton>
  );
};

AttachButton.defaultProps = {
  requiredPermissions: []
};

AttachButton.propTypes = {
  onClick: PropTypes.func,
  requiredPermissions: PropTypes.string,
  disabled: PropTypes.bool
};

export default AttachButton;
